const columnsAllCustomer = [
  {
    key: "no",
    title: "#",
    scopedSlots: { customRender: "no" },
  },
  {
    key: "name",
    title: "Khách hàng",
    dataIndex: "name",
    sorter: (a, b) => a.name && b.name && a.name.localeCompare(b.name),
  },
  {
    title: "Địa chỉ",
    key: "address",
    dataIndex: "tiaddresstle",
    scopedSlots: { customRender: "address" },
  },
  {
    title: "Mã thuế",
    dataIndex: "taxCode",
    key: "taxCode",
  },
  {
    title: "Điện thoại",
    key: "tel",
    dataIndex: "tel",
  },
  {
    title: "Người đại diện",
    key: "representedBy",
    dataIndex: "representedBy",
  },
  {
    title: "Ngày tạo",
    key: "createdAt",
    dataIndex: "createdAt",
    scopedSlots: { customRender: "createdAt" },
  },
  {
    title: "Cập nhật lần cuối",
    key: "updatedAt",
    dataIndex: "updatedAt",
    scopedSlots: { customRender: "updatedAt" },
  },
  {
    title: "",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];

export { columnsAllCustomer };
